// removed by extract-text-webpack-plugin
module.exports = {"pin":"lc_le","container":"lc_g"};


//////////////////
// WEBPACK FOOTER
// ./app/src/components/Iconography/components/Pin/styles.module.css
// module id = 1171
// module chunks = 27